import {
  Container,
  Box,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import parse from "html-react-parser";
import Axios from "axios";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Helmet } from "react-helmet-async";

import { Loading } from "../../components/shared/loading";
import { HeroParticles } from "../../components/shared/HeroParticles";
import { SocialShare } from "../../components/shared/SocialShare";
import { useToast } from "../../components/shared/Toast";
import { Reveal } from "../../components/shared/Reveal";

import { Link, useParams } from "react-router-dom";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 50%, #1a001a 100%)",
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  "@keyframes orbDrift": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(14px, -12px) scale(1.12)" },
  },
  "@keyframes orbDriftAlt": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(-16px, 10px) scale(1.08)" },
  },
  heroOrb: {
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(60px)",
    pointerEvents: "none",
    zIndex: 0,
  },
  heroOrbOne: {
    width: 340,
    height: 340,
    top: "-16%",
    right: "6%",
    background:
      "radial-gradient(circle, rgba(199,125,199,0.35), transparent 68%)",
    animation: "$orbDrift 9s ease-in-out infinite",
  },
  heroOrbTwo: {
    width: 300,
    height: 300,
    bottom: "-22%",
    left: "2%",
    background:
      "radial-gradient(circle, rgba(155,59,155,0.3), transparent 68%)",
    animation: "$orbDriftAlt 11s ease-in-out infinite",
  },
  heroEyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "2.4px",
    textTransform: "uppercase",
    color: "#e0b8e0",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(199,125,199,0.35)",
    borderRadius: 30,
    padding: "6px 16px",
    marginBottom: 18,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) both",
    "&::before": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "#c77dc7",
      boxShadow: "0 0 10px #c77dc7",
    },
  },
  heroTitle: {
    fontSize: "clamp(1.55rem, 3.6vw, 2.15rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  heroActions: {
    display: "flex",
    gap: "14px",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: 24,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.6s both",
  },
  heroPrimaryBtn: {
    background: "#ffffff",
    color: "#4c004c",
    padding: "12px 26px",
    fontSize: "0.86rem",
    fontWeight: 600,
    borderRadius: 12,
    textTransform: "none",
    boxShadow: "0 10px 26px rgba(0,0,0,0.28)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 16px 34px rgba(0,0,0,0.36)",
      background: "linear-gradient(135deg, #ffffff 0%, #f5e8f5 100%)",
    },
    "& .MuiButton-endIcon": {
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&:hover .MuiButton-endIcon": { transform: "translateX(4px)" },
  },
  heroGhostBtn: {
    background: "transparent",
    color: "#ffffff",
    padding: "12px 24px",
    fontSize: "0.86rem",
    fontWeight: 500,
    borderRadius: 12,
    textTransform: "none",
    border: "1px solid rgba(255,255,255,0.32)",
    transition: "all 0.3s ease",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#ffffff",
      textDecoration: "none",
    },
    "&:hover": {
      background: "rgba(255,255,255,0.08)",
      borderColor: "rgba(255,255,255,0.6)",
    },
  },
  pageWrapper: {
    background: "#f5f3f6",
    paddingTop: 0,
    paddingBottom: 60,
  },
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "0.78rem",
    color: "#6b1b6b",
    fontWeight: 500,
    textDecoration: "none",
    padding: "20px 0 16px",
    transition: "all 0.2s ease",
    "&, &:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
    },
    "&:hover": {
      color: "#4c004c",
      gap: "10px",
    },
  },
  contentContainer: {
    background: "#ffffff",
    borderRadius: 24,
    boxShadow: "0 12px 50px rgba(76,0,76,0.08)",
    overflow: "hidden",
    border: "1px solid rgba(76,0,76,0.04)",
  },

  // ── Image Banner ──
  imageSection: {
    position: "relative",
    width: "100%",
    background:
      "linear-gradient(135deg, #1a001a 0%, #2d002d 60%, #4c004c 100%)",
    padding: "56px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: "40px 24px",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      width: "55%",
      height: "70%",
      top: "-15%",
      right: "-15%",
      borderRadius: "50%",
      background:
        "radial-gradient(circle, rgba(199,125,199,0.4), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: "45%",
      height: "60%",
      bottom: "-15%",
      left: "-12%",
      borderRadius: "50%",
      background:
        "radial-gradient(circle, rgba(76,0,76,0.55), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
  },
  serviceImage: {
    position: "relative",
    zIndex: 1,
    maxWidth: "70%",
    maxHeight: 320,
    objectFit: "contain",
    display: "block",
    border: "none",
    filter: "drop-shadow(0 24px 50px rgba(0,0,0,0.45))",
    transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
    [theme.breakpoints.down("sm")]: {
      maxHeight: 200,
      maxWidth: "85%",
    },
    "&:hover": {
      transform: "scale(1.03)",
    },
  },

  // ── Service Meta ──
  serviceMeta: {
    padding: "32px 36px 20px",
    [theme.breakpoints.down("sm")]: {
      padding: "26px 22px 16px",
    },
  },
  serviceTagPill: {
    display: "inline-block",
    fontSize: "0.62rem",
    fontWeight: 700,
    color: "#9b3b9b",
    textTransform: "uppercase",
    letterSpacing: "1.8px",
    background:
      "linear-gradient(135deg, rgba(199,125,199,0.15), rgba(76,0,76,0.05))",
    border: "1px solid rgba(76,0,76,0.12)",
    borderRadius: 20,
    padding: "5px 12px",
    marginBottom: 12,
  },
  serviceTitle: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: 8,
    letterSpacing: "-0.01em",
    backgroundImage:
      "linear-gradient(90deg, #1a001a 0%, #4c004c 50%, #1a001a 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
  },
  serviceTagline: {
    fontSize: "0.88rem",
    color: "#666",
    lineHeight: 1.6,
    fontWeight: 400,
    maxWidth: 600,
  },

  // ── Share Bar ──
  shareBar: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "6px",
    padding: "16px 36px 18px",
    borderTop: "1px solid rgba(76,0,76,0.06)",
    borderBottom: "1px solid rgba(76,0,76,0.06)",
    background:
      "linear-gradient(180deg, transparent, rgba(199,125,199,0.04))",
    [theme.breakpoints.down("sm")]: {
      padding: "14px 22px 16px",
      gap: "5px",
    },
  },
  // ── Content ──
  serviceContent: {
    padding: "36px 36px 44px",
    [theme.breakpoints.down("sm")]: {
      padding: "26px 22px 32px",
    },
  },
  serviceBody: {
    fontSize: "0.95rem",
    color: "#2a2a2a",
    lineHeight: 1.9,
    fontWeight: 400,
    overflowWrap: "anywhere",
    "& p": {
      marginBottom: 20,
    },
    "& ul, & ol": {
      paddingLeft: 24,
      marginBottom: 20,
    },
    "& li": {
      marginBottom: 10,
    },
    "& h1, & h2, & h3, & h4": {
      color: "#4c004c",
      fontWeight: 600,
      marginTop: 32,
      marginBottom: 14,
    },
    "& h1": { fontSize: "1.35rem" },
    "& h2": { fontSize: "1.2rem" },
    "& h3": { fontSize: "1.05rem" },
    "& h4": { fontSize: "0.95rem" },
    "& table": {
      display: "block",
      width: "100%",
      overflowX: "auto",
      borderCollapse: "collapse",
    },
    "& th, & td": {
      border: "1px solid rgba(76,0,76,0.15)",
      padding: "8px 12px",
      fontSize: "0.85rem",
    },
    "& iframe": {
      maxWidth: "100%",
      border: 0,
    },
    "& pre": {
      overflowX: "auto",
      background: "#f6f0f6",
      borderRadius: 10,
      padding: "12px 14px",
      fontSize: "0.8rem",
    },
    "& img": {
      maxWidth: "100%",
      borderRadius: 12,
      margin: "24px 0",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    },
    "& a": {
      color: "#6b1b6b",
      textDecoration: "none",
      borderBottom: "1px solid rgba(107,27,107,0.3)",
      transition: "border-color 0.2s ease",
      "&:hover": {
        borderColor: "#6b1b6b",
      },
    },
    "& blockquote": {
      borderLeft: "3px solid #9b3b9b",
      margin: "24px 0",
      padding: "14px 22px",
      background: "rgba(155,59,155,0.04)",
      borderRadius: "0 12px 12px 0",
      fontStyle: "italic",
      color: "#555",
    },
  },

  // ── CTA ──
  ctaSection: {
    position: "relative",
    background:
      "linear-gradient(160deg, #4c004c 0%, #2d002d 60%, #1a001a 100%)",
    borderRadius: 24,
    padding: "48px 32px 44px",
    marginTop: 32,
    textAlign: "center",
    overflow: "hidden",
    boxShadow: "0 16px 50px rgba(76,0,76,0.25)",
    "&::before": {
      content: '""',
      position: "absolute",
      width: 360,
      height: 360,
      borderRadius: "50%",
      top: -140,
      right: -140,
      background:
        "radial-gradient(circle, rgba(199,125,199,0.4), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      borderRadius: "50%",
      bottom: -140,
      left: -140,
      background:
        "radial-gradient(circle, rgba(155,59,155,0.32), transparent 70%)",
      filter: "blur(50px)",
      pointerEvents: "none",
    },
  },
  ctaLabel: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "#c77dc7",
    textTransform: "uppercase",
    letterSpacing: "2.2px",
    marginBottom: 10,
  },
  ctaTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.5rem",
    fontWeight: 700,
    color: "#ffffff",
    letterSpacing: "-0.01em",
    lineHeight: 1.25,
    maxWidth: 480,
    margin: "0 auto 26px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
  },
  ctaButton: {
    position: "relative",
    zIndex: 1,
    background: "#ffffff",
    color: "#4c004c",
    padding: "13px 32px",
    fontSize: "0.88rem",
    fontWeight: 600,
    borderRadius: 14,
    textTransform: "none",
    letterSpacing: "0.2px",
    boxShadow: "0 8px 22px rgba(0,0,0,0.18)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "& .MuiButton-startIcon": {
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "& .MuiButton-endIcon": {
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "&:hover": {
      background: "linear-gradient(135deg, #ffffff 0%, #f5e8f5 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 14px 32px rgba(0,0,0,0.28)",
    },
    "&:hover .MuiButton-endIcon": {
      transform: "translateX(4px)",
    },
  },
}));


export const ServiceDetails = () => {
  const classes = useStyles();
  let { id } = useParams();
  const url=window.location.href;
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  const [service, setService] = useState(true);


  const toast = useToast();
  const openSnkbar = (type, msg) => toast.show(type, msg);


  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };


  useEffect(() => {
    setIsloading(true);
    getMetaData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("id", id);

    Axios.post("/api/getsingleservice", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.serv_title);
        setMetaKeywords(res.data.data.serv_keywords);
        setMetaDesc(res.data.data.serv_metadesc);
        setService(res.data.data);
        setIsloading(false);
        handleClick();
      }
    });
  };

  return (
    <div>
      {service && !isloading ? (
        <div>
          <Helmet>
            <title>{metaTitle + " | Arawinz Soft Solutions"}</title>
            <meta name="description" content={metaDesc} />
            <meta name="keywords" content={metaKeywords}></meta>
          </Helmet>

          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <HeroParticles id="servicedetails-hero-particles" />
            <Box className={`${classes.heroOrb} ${classes.heroOrbOne}`} />
            <Box className={`${classes.heroOrb} ${classes.heroOrbTwo}`} />
            <Box className={classes.heroContent}>
              <span className={classes.heroEyebrow}>Service</span>
              <Typography className={classes.heroTitle}>
                {service.serv_name}
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Professional IT Solutions by Arawinz
              </Typography>
              <Box className={classes.heroActions}>
                <Button
                  component={Link}
                  to={`/get-in-touch?subject=${encodeURIComponent(
                    service.serv_name || ""
                  )}`}
                  className={classes.heroPrimaryBtn}
                  endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                >
                  Get in Touch
                </Button>
                <Button
                  component={Link}
                  to="/our-services"
                  className={classes.heroGhostBtn}
                >
                  All services
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Content Section */}
          <Box className={classes.pageWrapper}>
            <Container maxWidth="md">
              {/* Back Link */}
              <Link to="/our-services" className={classes.backLink}>
                ← Back to Services
              </Link>

              {/* Service Card */}
              <Box className={classes.contentContainer}>
                {/* Image Banner */}
                <Reveal>
                  <Box className={classes.imageSection}>
                    <img
                      src={`/static/services/${service.serv_image}`}
                      alt={service.serv_name}
                      className={classes.serviceImage}
                    />
                  </Box>
                </Reveal>

                {/* Meta Section */}
                <Reveal>
                  <Box className={classes.serviceMeta}>
                    <Typography className={classes.serviceTagPill}>
                      Service
                    </Typography>
                    <Typography className={classes.serviceTitle}>
                      {service.serv_name}
                    </Typography>
                    <Typography className={classes.serviceTagline}>
                      Expert solutions built around your business needs
                    </Typography>
                  </Box>
                </Reveal>

                {/* Share Bar */}
                <Box className={classes.shareBar}>
                  <SocialShare url={url} />
                </Box>

                {/* Service Content */}
                <Reveal>
                  <Box className={classes.serviceContent}>
                    <Box className={classes.serviceBody}>
                      {parse(service.serv_desc)}
                    </Box>
                  </Box>
                </Reveal>
              </Box>

              {/* CTA Section */}
              <Reveal>
                <Box className={classes.ctaSection}>
                  <Typography className={classes.ctaLabel}>
                    Ready to start
                  </Typography>
                  <Typography className={classes.ctaTitle}>
                    Let's discuss how we can help your business grow.
                  </Typography>
                  <Button
                    component={Link}
                    to={`/get-in-touch?subject=${encodeURIComponent(service.serv_name || "")}`}
                    className={classes.ctaButton}
                    endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                  >
                    Get in Touch
                  </Button>
                </Box>
              </Reveal>

            </Container>
          </Box>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

